import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { Link, useHistory } from "react-router-dom";
import httpServices from "../../../services/httpServices/httpServices";
import Sidebar from "../../partials/aside/Sidebar";
import TitleBar from "../../partials/content/TitleBar";
import helperSpinner from "../../../helpers/spinner";
import messageValidation from "../../../messages/publisher";

export default function AddImage() {
  const params = useParams();
  const history = useHistory();
  const publisherID = parseInt(params.publisherID);
  const [sitePublisher, setSitePublisher] = useState();
  const [imageSitePublisher, setImageSitePublisher] = useState();
  const [imageFile, setImageFile] = useState();
  const [message, setMessage] = useState();

  useEffect(() => {
    getImageSitePublisher();
  }, []);

  useEffect(() => {
    if (!imageSitePublisher) {
      return;
    }
    getSitePublisher();
  }, [imageSitePublisher]);

  let messageTag;
  if (message) {
    messageTag = (
      <div className={`${message.type_class}`}>
        <i className={`${message.class_icon} pl-2`}></i>
        <span>{message.text}</span>
      </div>
    );
  }

  const getImageSitePublisher = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    let imageSitePublisher = await sendRequestGetImageSitePublisher(
      publisherID
    );
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!imageSitePublisher) {
      return;
    }

    setImageSitePublisher(imageSitePublisher.url);
  };

  const sendRequestGetImageSitePublisher = async (publisherID) => {
    const headersRequest = getHeaderRequest();
    let imageSitePublisher;
    try {
      imageSitePublisher = await httpServices.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          `/v1/publisher/site/${publisherID}/get-image`,
        headersRequest
      );
    } catch (error) {
      // alert(error.response.data.message);
      return false;
    }

    return imageSitePublisher.data.data;
  };

  const getSitePublisher = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    let sitePublisher = await sendRequestGetSitePublisher(publisherID);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!sitePublisher) {
      return;
    }
    setSitePublisher(sitePublisher);
  };

  const sendRequestGetSitePublisher = async (publisherID) => {
    const headersRequest = getHeaderRequest();
    let pages;
    try {
      pages = await httpServices.getRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/publisher/site/" + publisherID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return pages.data.data;
  };

  const getHeaderRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const sendFrom = async () => {
    if (!imageFile) {
      alert("لطفا عکس وارد کنید.");
      return;
    }
    const formData = getDataForRequest();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultAddImageToPositionIndependent =
      await sendRequestAddImageToPositionIndependent(publisherID, formData);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!resultAddImageToPositionIndependent) {
      return;
    }

    history.push(
      `/positions/independent/all/web-site-publisher/${publisherID}`
    );
  };

  const sendRequestAddImageToPositionIndependent = async (
    publisherID,
    formData
  ) => {
    const headersRequest = getHeaderForRequest();
    try {
      await httpServices.postRequest(
        process.env.REACT_APP_DOMAIN_API +
          `/v1/publisher/site/${publisherID}/add-image`,
        formData,
        headersRequest
      );
      return true;
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const getDataForRequest = () => {
    const formData = new FormData();
    formData.append("file", imageFile);
    return formData;
  };

  const generateImageSitePublisher = () => {
    return (
      <div className="pt-3">
        <a href={imageSitePublisher} target="_blank">
          <img
            className="border border-success img-fluid"
            src={imageSitePublisher}
          />
        </a>
      </div>
    );
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <TitleBar
          title={` جایگاه های مستقل سایت ${sitePublisher?.url.replace(
            "https://",
            ""
          )}`}
        />
        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <div className="text-left pb-2">
                <Link
                  className="btn btn-primary"
                  to={`/positions/independent/all/web-site-publisher/${publisherID}`}
                >
                  <span>بازگشت</span>
                  <span className="pr-2">
                    <i className="fas fa-arrow-left"></i>
                  </span>
                </Link>
              </div>
              {messageTag}
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  sendFrom();
                }}
              >
                <div className="d-flex align-items-end ">
                  <div className="form-group m-0">
                    <label>عکس جایگاه نمایش دهنده مستقل را آپلود کنید</label>
                    <input
                      type="file"
                      name="file"
                      className="form-control"
                      accept="image/webp"
                      onChange={(e) => {
                        e.preventDefault();
                        const file = e.target.files[0];
                        if (file.type != "image/webp") {
                          setMessage({
                            type_class: "alert alert-danger",
                            text: messageValidation.TYPE_IMAGE_IS_INVALID,
                            class_icon: "fa fa-exclamation-triangle",
                          });
                          return;
                        }
                        setImageFile(file);
                      }}
                    />
                  </div>
                  <div className="pr-2">
                    <button type="submit" className="btn btn-success">
                      درج
                    </button>
                  </div>
                </div>

                <div>{imageSitePublisher && generateImageSitePublisher()}</div>
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
